
export const isTrainer = (project) => {
    return true
};

export const isInternalTrainer = (project) => {
    return true
};
